import { useTranslation } from 'react-i18next';

// Remove the constant and create a function to get the translated text
export const useGuestAccessLinkLabel = () => {
  const { t } = useTranslation();
  return t('Avigilon Alta Guest Access link');
};
